module.exports = __webpack_public_path__ + "img/goal-target_increase.e208489.svg";